import { renderToStaticMarkup } from "react-dom/server";
import { ChatAppResponse, getCitationFilePath, Citation } from "../../api";

type HtmlParsedAnswer = {
    answerHtml: string;
    citations: Citation[];
};

export function parseAnswerToHtml(answer: ChatAppResponse, isStreaming: boolean, onCitationClicked: (citation: Citation) => void): HtmlParsedAnswer {
    const possibleCitations = answer.context?.data_points?.citations || [];
    const citations: Citation[] = [];

    // Trim any whitespace from the end of the answer after removing follow-up questions
    let parsedAnswer = (answer.message?.content ?? "").trim();

    // Omit a citation that is still being typed during streaming
    if (isStreaming) {
        let lastIndex = parsedAnswer.length;
        for (let i = parsedAnswer.length - 1; i >= 0; i--) {
            if (parsedAnswer[i] === "]") {
                break;
            } else if (parsedAnswer[i] === "[") {
                lastIndex = i;
                break;
            }
        }
        const truncatedAnswer = parsedAnswer.substring(0, lastIndex);
        parsedAnswer = truncatedAnswer;
    }

    const parts = parsedAnswer.split(/\[([^\]]+)\]/g);

    const fragments: string[] = parts.map((part, index) => {
        if (index % 2 === 0) {
            return part;
        } else {
            let citationIndex: number;

            const matchingCitation = possibleCitations.find(citation => {
                return citation.filename.startsWith(part) || part.startsWith(citation.filename);
            });

            if (!matchingCitation) {
                return `[${part}]`;
            }

            const existingIndex = citations.findIndex(c => c.filename === matchingCitation.filename);
            if (existingIndex !== -1) {
                citationIndex = existingIndex + 1;
            } else {
                citations.push(matchingCitation);
                citationIndex = citations.length;
            }

            return renderToStaticMarkup(
                <a className="supContainer" title={matchingCitation.filename} data-citation-index={citationIndex - 1}>
                    <sup>{citationIndex}</sup>
                </a>
            );
        }
    });

    return {
        answerHtml: fragments.join(""),
        citations
    };
}
